import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Radio} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Radio, {
            'name': 'language',
            'trueValue': 'Javascript',
            'children': 'Javascript',
            'ev-$model:value': function($v) {
                $this.set('language', $v);
            },
            'value': $this.get('language')
        }),
        _$cc(Radio, {
            'name': 'language',
            'trueValue': 'C++',
            'children': 'C++',
            'ev-$model:value': function($v) {
                $this.set('language', $v);
            },
            'value': $this.get('language')
        }),
        _$cc(Radio, {
            'name': 'language',
            'trueValue': 'PHP',
            'children': 'PHP',
            'ev-$model:value': function($v) {
                $this.set('language', $v);
            },
            'value': $this.get('language')
        }),
        _$ct('\n    Your selected: '),
        this.get('language')
    ], 0);
};